var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSjLogoSchriftzugWeiTransp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 431.25 120.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SJ_LogoSchriftzug_wei\xDF-transp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc19bfac-facd-4a68-a52b-413c497e58be",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0e53e12d-c23f-45a8-877f-8acae2c9c547",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 87.53)",
    fontSize: 102,
    fill: "#fff",
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.01em"
  }, "Sp", /*#__PURE__*/React.createElement("tspan", {
    x: 126.8,
    y: 0,
    xmlSpace: "preserve",
    letterSpacing: "0.04em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 191.23,
    y: 0,
    letterSpacing: "0.05em"
  }, "rt"), /*#__PURE__*/React.createElement("tspan", {
    x: 263.74,
    y: 0,
    letterSpacing: "0.01em"
  }, "Joe")), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,73.44a81,81,0,0,0-8.29-2.28,42.26,42.26,0,0,1-9-2.9,12.64,12.64,0,0,1-5-4.34,10.47,10.47,0,0,1-1.49-4c0,.49,0,1,0,1.5a27.94,27.94,0,0,0,18.91,26.43,16.32,16.32,0,0,0,5-1,8.65,8.65,0,0,0,4-2.88,6.68,6.68,0,0,0,1.32-4,6.08,6.08,0,0,0-1.28-3.83A9.34,9.34,0,0,0,154.59,73.44Zm29.92-22.73V58A23.17,23.17,0,0,1,183.09,67a10,10,0,0,1-4.48,4.89,14.73,14.73,0,0,1-7.2,1.68q-6.12,0-9.39-3.52-3.06-3.33-3.13-9.71h5.68c.26,2.73.88,4.65,1.89,5.77a6.3,6.3,0,0,0,4.92,2,7.37,7.37,0,0,0,4-1.07,5.5,5.5,0,0,0,2.32-2.89,19.47,19.47,0,0,0,.63-5.83V41.59A27.92,27.92,0,0,0,132.5,51.86a2.9,2.9,0,0,1,.2-.33,12.35,12.35,0,0,1,5.84-4.66,22.22,22.22,0,0,1,8.55-1.59A23.43,23.43,0,0,1,156.23,47a13.2,13.2,0,0,1,6.08,4.91,13.91,13.91,0,0,1,2.23,6.48h-6.06a9,9,0,0,0-3-5.37q-2.75-2.25-8.12-2.25-5.58,0-8.15,2.05a6.14,6.14,0,0,0-2.55,4.94,5.29,5.29,0,0,0,1.81,4.13q1.77,1.62,9.29,3.32a60.77,60.77,0,0,1,10.31,3,14.11,14.11,0,0,1,6,4.75A11.61,11.61,0,0,1,166,79.51a12.66,12.66,0,0,1-2.13,7,13,13,0,0,1-2.39,2.74,28,28,0,0,0,23-38.54Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSjLogoSchriftzugWeiTransp);
export default __webpack_public_path__ + "static/media/SJ_LogoSchriftzug_weiß-transp.f007bc4bf42ef1347931179399dbcf9a.svg";
export { ForwardRef as ReactComponent };